<template>
  <component
    :is="vueComponentData.name"
    v-bind="vueComponentData.props"
  />
</template>

<script>
import ClientHomeChatLinkButton from './ClientHomeChatLinkButton.vue'
import ClientHomePageSupportForm from './ClientHomePageSupportForm.vue'

export default {
  name: 'ClientHomePageChatWidget',
  components: {
    ClientHomeChatLinkButton,
    ClientHomePageSupportForm,
  },
  props: {
    componentName: {
      type: String,
      required: true,
    },
    componentData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    vueComponentData() {
      switch(this.componentName) {
        case 'navigate': {
          const destination = this.componentData.destination
          const routeInfo = ROUTES[destination] ?? FALLBACK_ROUTE
          if (!routeInfo)
            return

          const props = {
            link: routeInfo.route,
            text: routeInfo.displayName,
            subtext: 'Click to go',
          }
          return { name: 'ClientHomeChatLinkButton', props: props }
        }
        case 'support': {
            const props = {
              description: this.componentData.description,
              issue: this.componentData.issue,
              priority: this.componentData.priority,
              locationId: this.componentData.location_id,
              type: this.componentData.type,
            }
          return { name: 'ClientHomePageSupportForm', props: props }
        }
        default: {
          console.error(`Unknown component name: ${this.componentName}`)
          return ''
        }
      }
    },
  },
}

const FALLBACK_ROUTE = {
  route: '/client/home',
  displayName: 'Home',
}

const ROUTES = {
  'marketplace': {
    route: '/client/marketplace',
    displayName: 'Marketplace',
  },
  'my_pantry': {
    route: '/client/my_pantry',
    displayName: 'My Pantry',
  },
  'orders': {
    route: '/client/orders',
    displayName: 'Orders Page',
  },
  'support': {
    route: '/client/support',
    displayName: 'Support',
  },
  'settings': {
    route: '/client/settings',
    displayName: 'Settings',
  },
  'email_preferences': {
    route: '/client/settings?tab=email-preferences',
    displayName: 'Email Preferences',
  },
  'users_settings': {
    route: '/client/settings?tab=users',
    displayName: 'Users Settings',
  },
  'analytics': {
    route: '/client/analytics',
    displayName: 'Analytics Page',
  },
  'total_spend': {
    route: '/client/analytics/total_spend',
    displayName: 'Total Spend',
  },
  'product_performance': {
    route: '/client/analytics/product_performance',
    displayName: 'Product Performance',
  },
  'product_spend': {
    route: '/client/analytics/product_report',
    displayName: 'Product Spend',
  },
  'account_spend': {
    route: '/client/analytics/spend_by_location',
    displayName: 'Account Spend',
  },
  'category_spend': {
    route: '/client/analytics/spend_by_category',
    displayName: 'Category Spend',
  },
  'subcategory_spend': {
    route: '/client/analytics/spend_by_subcategory',
    displayName: 'Subcategory Spend',
  },
  'weekly_schedule': {
    route: '/client/schedule/weekly_schedule',
    displayName: 'Weekly Schedule',
  },
  'service_disruptions': {
    route: '/client/schedule/service_disruptions',
    displayName: 'Service Disruptions',
  },
}

</script>
